module.exports = __webpack_public_path__ + "static/Crown-d1fd18f365522ebb9ad655599860046d.jpg";